export default "__VITE_ASSET__DgO4RJnt__"